import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { SharedLayout } from '../components/layout/SharedLayout';
import { theme } from '../styles/theme';

const HeroSection = styled.section`
  background: #232B3B;
  padding: 100px 20px 80px;
  margin-top: -80px;
  padding-top: 140px;
  color: white;
  text-align: center;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('/650f1c8c6cf62f0b696c3d20_Lake2.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 0.15;
    z-index: 0;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`;

const PageTitle = styled.h1`
  font-size: clamp(36px, 5vw, 56px);
  font-weight: 800;
  margin-bottom: 20px;
  letter-spacing: -1px;
`;

const PageSubtitle = styled.p`
  font-size: clamp(18px, 2.5vw, 24px);
  opacity: 0.9;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.5;
`;

const ResourcesSection = styled.section`
  padding: 80px 20px;
  background: #f8f9fa;
`;

const CategorySection = styled.div`
  margin-bottom: 80px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const CategoryHeader = styled.div`
  text-align: center;
  margin-bottom: 50px;
`;

const CategoryBadge = styled.div`
  display: inline-block;
  background: linear-gradient(135deg, #ffd700 0%, #ffed4e 100%);
  color: #333;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 20px;
`;

const CategoryTitle = styled.h2`
  font-size: clamp(32px, 4vw, 42px);
  font-weight: 800;
  color: #333;
  margin-bottom: 15px;
`;

const CategoryDescription = styled.p`
  font-size: 18px;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
`;

const ResourceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
`;

const ResourceCard = styled(Link)`
  background: white;
  border-radius: 15px;
  padding: 35px;
  text-decoration: none;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.06);
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);
    
    .arrow {
      transform: translateX(5px);
    }
  }
`;

const ResourceIcon = styled.div`
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #232B3B 0%, #1a1f2e 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-bottom: 20px;
`;

const ResourceTitle = styled.h3`
  font-size: 22px;
  font-weight: bold;
  color: #333;
  margin-bottom: 12px;
`;

const ResourceDescription = styled.p`
  font-size: 15px;
  color: #666;
  line-height: 1.6;
  flex-grow: 1;
  margin-bottom: 20px;
`;

const ResourceMeta = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  border-top: 1px solid #eee;
`;

const ResourceType = styled.span`
  font-size: 12px;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const ResourceArrow = styled.span`
  color: #ffd700;
  font-size: 18px;
  transition: transform 0.3s;
`;

const FeaturedResource = styled.div`
  background: linear-gradient(135deg, #232B3B 0%, #1a1f2e 100%);
  border-radius: 20px;
  padding: 60px;
  margin-bottom: 80px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
  color: white;
  
  @media (max-width: ${theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
    padding: 40px;
    gap: 30px;
  }
`;

const FeaturedContent = styled.div``;

const FeaturedBadge = styled.div`
  display: inline-block;
  background: #ffd700;
  color: #333;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 20px;
`;

const FeaturedTitle = styled.h2`
  font-size: clamp(32px, 4vw, 42px);
  font-weight: 800;
  margin-bottom: 20px;
  line-height: 1.2;
`;

const FeaturedDescription = styled.p`
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: 30px;
  opacity: 0.9;
`;

const FeaturedCTA = styled(Link)`
  display: inline-block;
  background: linear-gradient(135deg, #ffd700 0%, #ffed4e 100%);
  color: #333;
  padding: 16px 32px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: bold;
  font-size: 16px;
  transition: all 0.3s;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 30px rgba(255, 215, 0, 0.3);
  }
`;

const FeaturedVisual = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const EbookCover = styled.img`
  width: 100%;
  max-width: 300px;
  height: auto;
  border-radius: 10px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
`;

const VideoSection = styled.section`
  background: white;
  padding: 80px 20px;
`;

const VideoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
`;

const VideoCard = styled.div`
  background: #f8f9fa;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.06);
`;

const VideoThumbnail = styled.div`
  background: linear-gradient(135deg, #232B3B 0%, #1a1f2e 100%);
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 60px;
  position: relative;
  
  &::after {
    content: '▶';
    position: absolute;
    color: white;
    font-size: 40px;
    background: rgba(0, 0, 0, 0.5);
    width: 70px;
    height: 70px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const VideoInfo = styled.div`
  padding: 25px;
`;

const VideoTitle = styled.h3`
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
`;

const VideoDuration = styled.span`
  font-size: 14px;
  color: #999;
`;

const CTASection = styled.section`
  background: #f8f9fa;
  padding: 80px 20px;
`;

const CTAContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  background: #232B3B;
  border-radius: 20px;
  padding: 60px 40px;
  text-align: center;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('/650f1c8c6cf62f0b696c3d20_Lake2.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 0.1;
    z-index: 0;
  }
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: 40px 20px;
  }
`;

const CTAInner = styled.div`
  position: relative;
  z-index: 1;
  max-width: 800px;
  margin: 0 auto;
`;

const CTATitle = styled.h2`
  font-size: clamp(32px, 4vw, 42px);
  font-weight: 800;
  color: white;
  margin-bottom: 20px;
`;

const CTAText = styled.p`
  font-size: 20px;
  color: white;
  margin-bottom: 40px;
  opacity: 0.9;
  line-height: 1.6;
`;

const CTAButton = styled(Link)`
  display: inline-block;
  background: linear-gradient(135deg, #ffd700 0%, #ffed4e 100%);
  color: #232B3B;
  padding: 18px 40px;
  border-radius: 8px;
  font-weight: bold;
  font-size: 18px;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: all 0.3s;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 15px 40px rgba(255, 215, 0, 0.4);
  }
`;

export const Resources: React.FC = () => {
  return (
    <SharedLayout>
      <HeroSection>
        <Container>
          <PageTitle>Education & Resources</PageTitle>
          <PageSubtitle>
            Everything you need to understand annuities and make informed retirement decisions
          </PageSubtitle>
        </Container>
      </HeroSection>

      <ResourcesSection>
        <Container>
          <FeaturedResource>
            <FeaturedContent>
              <FeaturedBadge>Free Download</FeaturedBadge>
              <FeaturedTitle>Demystifying Annuities: The Complete Guide</FeaturedTitle>
              <FeaturedDescription>
                Our comprehensive 50-page guide covers everything from annuity basics to advanced 
                strategies. Learn how to avoid common pitfalls and maximize your retirement income.
              </FeaturedDescription>
              <FeaturedCTA to="/free-ebook">
                Download Free eBook
              </FeaturedCTA>
            </FeaturedContent>
            <FeaturedVisual>
              <EbookCover src="/ebook-cover.png" alt="Demystifying Annuities eBook Cover" />
            </FeaturedVisual>
          </FeaturedResource>

          <CategorySection>
            <CategoryHeader>
              <CategoryBadge>Getting Started</CategoryBadge>
              <CategoryTitle>Annuity Basics</CategoryTitle>
              <CategoryDescription>
                New to annuities? Start here with our foundational guides and resources
              </CategoryDescription>
            </CategoryHeader>
            <ResourceGrid>
              <ResourceCard to="/annuity-basics">
                <ResourceIcon>📖</ResourceIcon>
                <ResourceTitle>What is an Annuity?</ResourceTitle>
                <ResourceDescription>
                  Learn the fundamentals of how annuities work, different types available, and 
                  whether they might be right for your retirement plan.
                </ResourceDescription>
                <ResourceMeta>
                  <ResourceType>Guide</ResourceType>
                  <ResourceArrow className="arrow">→</ResourceArrow>
                </ResourceMeta>
              </ResourceCard>

              <ResourceCard to="/solutions">
                <ResourceIcon></ResourceIcon>
                <ResourceTitle>Types of Annuities Explained</ResourceTitle>
                <ResourceDescription>
                  Compare fixed, variable, and indexed annuities. Understand the pros, cons, and 
                  ideal scenarios for each type.
                </ResourceDescription>
                <ResourceMeta>
                  <ResourceType>Comparison</ResourceType>
                  <ResourceArrow className="arrow">→</ResourceArrow>
                </ResourceMeta>
              </ResourceCard>

              <ResourceCard to="/inflation-protection">
                <ResourceIcon></ResourceIcon>
                <ResourceTitle>Inflation Protection Strategies</ResourceTitle>
                <ResourceDescription>
                  Learn how to protect your retirement income from inflation with the right 
                  annuity strategies and riders.
                </ResourceDescription>
                <ResourceMeta>
                  <ResourceType>Guide</ResourceType>
                  <ResourceArrow className="arrow">→</ResourceArrow>
                </ResourceMeta>
              </ResourceCard>
            </ResourceGrid>
          </CategorySection>

          <CategorySection>
            <CategoryHeader>
              <CategoryBadge>Advanced Topics</CategoryBadge>
              <CategoryTitle>Deep Dive Resources</CategoryTitle>
              <CategoryDescription>
                Ready to go deeper? Explore advanced strategies and detailed analysis
              </CategoryDescription>
            </CategoryHeader>
            <ResourceGrid>
              <ResourceCard to="/ai-backtester">
                <ResourceIcon></ResourceIcon>
                <ResourceTitle>Deep Dive Tool</ResourceTitle>
                <ResourceDescription>
                  Use our proprietary tool to analyze annuity performance across different 
                  market conditions and time periods with deep dive studies.
                </ResourceDescription>
                <ResourceMeta>
                  <ResourceType>Tool</ResourceType>
                  <ResourceArrow className="arrow">→</ResourceArrow>
                </ResourceMeta>
              </ResourceCard>

              <ResourceCard to="/averill-method">
                <ResourceIcon></ResourceIcon>
                <ResourceTitle>The Averill Method</ResourceTitle>
                <ResourceDescription>
                  Discover our proprietary methodology for evaluating and optimizing annuity 
                  performance based on real market data.
                </ResourceDescription>
                <ResourceMeta>
                  <ResourceType>Methodology</ResourceType>
                  <ResourceArrow className="arrow">→</ResourceArrow>
                </ResourceMeta>
              </ResourceCard>

              <ResourceCard to="/retirement-calculator">
                <ResourceIcon></ResourceIcon>
                <ResourceTitle>Retirement Income Calculator</ResourceTitle>
                <ResourceDescription>
                  Calculate your retirement income needs and see how annuities can provide 
                  guaranteed lifetime income.
                </ResourceDescription>
                <ResourceMeta>
                  <ResourceType>Calculator</ResourceType>
                  <ResourceArrow className="arrow">→</ResourceArrow>
                </ResourceMeta>
              </ResourceCard>
            </ResourceGrid>
          </CategorySection>

          <CategorySection>
            <CategoryHeader>
              <CategoryBadge>Planning Tools</CategoryBadge>
              <CategoryTitle>Worksheets & Checklists</CategoryTitle>
              <CategoryDescription>
                Practical tools to help you evaluate and track your retirement planning
              </CategoryDescription>
            </CategoryHeader>
            <ResourceGrid>
              <ResourceCard to="/compare">
                <ResourceIcon>📊</ResourceIcon>
                <ResourceTitle>Compare Annuity Options</ResourceTitle>
                <ResourceDescription>
                  Use our comparison tool to evaluate different annuity products side-by-side 
                  based on your specific needs and goals.
                </ResourceDescription>
                <ResourceMeta>
                  <ResourceType>Tool</ResourceType>
                  <ResourceArrow className="arrow">→</ResourceArrow>
                </ResourceMeta>
              </ResourceCard>

              <ResourceCard to="/analyze">
                <ResourceIcon>🔍</ResourceIcon>
                <ResourceTitle>Analyze Your Annuity</ResourceTitle>
                <ResourceDescription>
                  Get a comprehensive analysis of your existing annuity or evaluate potential 
                  new annuity purchases.
                </ResourceDescription>
                <ResourceMeta>
                  <ResourceType>Analysis Tool</ResourceType>
                  <ResourceArrow className="arrow">→</ResourceArrow>
                </ResourceMeta>
              </ResourceCard>

              {/* <ResourceCard to="/find-advisor">
                <ResourceIcon>👥</ResourceIcon>
                <ResourceTitle>Find a Trusted Advisor</ResourceTitle>
                <ResourceDescription>
                  Connect with qualified advisors who can help you navigate annuity decisions 
                  and retirement planning.
                </ResourceDescription>
                <ResourceMeta>
                  <ResourceType>Directory</ResourceType>
                  <ResourceArrow className="arrow">→</ResourceArrow>
                </ResourceMeta>
              </ResourceCard> */}
            </ResourceGrid>
          </CategorySection>
        </Container>
      </ResourcesSection>

      {/* <VideoSection>
        <Container>
          <CategoryHeader>
            <CategoryBadge>Video Library</CategoryBadge>
            <CategoryTitle>Learn Through Video</CategoryTitle>
            <CategoryDescription>
              Visual learner? Watch our educational videos on key annuity topics
            </CategoryDescription>
          </CategoryHeader>
          <VideoGrid>
            <VideoCard>
              <VideoThumbnail>🎥</VideoThumbnail>
              <VideoInfo>
                <VideoTitle>How the Deep Dive Tool Works</VideoTitle>
                <VideoDuration>8:45</VideoDuration>
              </VideoInfo>
            </VideoCard>

            <VideoCard>
              <VideoThumbnail>🎬</VideoThumbnail>
              <VideoInfo>
                <VideoTitle>Understanding Indexed Annuities</VideoTitle>
                <VideoDuration>12:30</VideoDuration>
              </VideoInfo>
            </VideoCard>

            <VideoCard>
              <VideoThumbnail>📹</VideoThumbnail>
              <VideoInfo>
                <VideoTitle>The Averill Method Explained</VideoTitle>
                <VideoDuration>15:20</VideoDuration>
              </VideoInfo>
            </VideoCard>
          </VideoGrid>
        </Container>
      </VideoSection> */}

      <CTASection>
        <CTAContent>
          <CTAInner>
            <CTATitle>Transform Your Retirement Knowledge Into Action</CTATitle>
            <CTAText>
              You've explored our resources - now let's put that knowledge to work. 
              Get personalized guidance from our AI-powered experts who will help you 
              navigate your specific retirement situation.
            </CTAText>
            <CTAButton to="/retirevana">
              Book Your Free Strategy Session
            </CTAButton>
          </CTAInner>
        </CTAContent>
      </CTASection>
    </SharedLayout>
  );
};